import { Grid, Stack } from '@mui/material';
import { modalContainerHeight, modalOverflowBoxStyles } from '~/components/styles';
import {
  AnatomyField,
  DataSourceCategoryField,
  DataSourceTypeField,
  DimensionalityField,
  LegalRelationshipField,
  LegalRelationshipQualifierField,
  ModalityField,
  RestrictionTagField,
  SitesField,
  VisitTypeField,
} from '..';

const DataTagsForm = () => {
  const formConfig = [
    { field: <DataSourceCategoryField />, size: 6 },
    { field: <DataSourceTypeField />, size: 6 },
    { field: <LegalRelationshipField />, size: 6 },
    { field: <LegalRelationshipQualifierField />, size: 6 },
    { field: <AnatomyField />, size: 6 },
    { field: <ModalityField />, size: 6 },
    { field: <DimensionalityField />, size: 6 },
    { field: <RestrictionTagField />, size: 6 },
    { field: <VisitTypeField />, size: 6 },
    { field: <SitesField />, size: 6 },
  ];

  return (
    <Stack sx={{ ...modalOverflowBoxStyles, height: `calc(${modalContainerHeight} - 240px)` }} spacing={2}>
      <Grid container spacing={4}>
        {formConfig.map(({ field, size }, index) => (
          <Grid key={index} size={size}>
            {field}
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default DataTagsForm;
